export default __webpack_public_path__ + "static/media/marketplace.11988136.png";